import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MyCustomerApiRequest } from '../services/customerService';

// Helper function to load filter from localStorage
const loadFilterFromStorage = (): Partial<MyCustomerApiRequest> => {
  try {
    const savedFilter = localStorage.getItem('customerSearchFilter');
    return savedFilter ? JSON.parse(savedFilter) : { customerType: 'company' };
  } catch (error) {
    console.error("Could not load customer search filter from localStorage:", error);
    return { customerType: 'company' };
  }
};

// Helper function to save filter to localStorage
const saveFilterToStorage = (filter: Partial<MyCustomerApiRequest>) => {
  try {
    localStorage.setItem('customerSearchFilter', JSON.stringify(filter));
  } catch (error) {
    console.error("Could not save customer search filter to localStorage:", error);
  }
};

// Slice state
interface CustomerSearchFilterState {
  filter: Partial<MyCustomerApiRequest>;
}

// Initial state
const initialState: CustomerSearchFilterState = {
  filter: loadFilterFromStorage(),
};

// Create slice
const customerSearchFilterSlice = createSlice({
  name: 'customerSearchFilter',
  initialState,
  reducers: {
    setCustomerSearchFilter(state, action: PayloadAction<Partial<MyCustomerApiRequest>>) {
      state.filter = action.payload;
      saveFilterToStorage(action.payload);
    },
    resetCustomerSearchFilter(state) {
      const defaultFilter = { customerType: 'company' as const };
      state.filter = defaultFilter;
      saveFilterToStorage(defaultFilter);
    },
  },
});

// Export actions
export const { setCustomerSearchFilter, resetCustomerSearchFilter } = customerSearchFilterSlice.actions;

// Export reducer
export default customerSearchFilterSlice.reducer;